(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('DoseForm', DoseForm);

    DoseForm.$inject = ['$resource'];

    function DoseForm ($resource) {
        var resourceUrl =  'api/dose-forms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByMedication': {method: 'GET', isArray: true, url: 'api/dose-forms/by-medication/:id'},
            'findAllByCorporation': {url: 'api/dose-forms/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
